/** @format */

import { Component, Input } from '@angular/core';
import { HmfCardComponent, HmfTextLinkComponent } from '@dsg-tech/homefield-angular';

import { MediaModule } from '@shared/media/components';

@Component({
	selector: 'plp-components-feature-spot',
	templateUrl: './feature-spot.component.html',
	styleUrl: './feature-spot.component.scss',
	imports: [MediaModule, HmfCardComponent, HmfTextLinkComponent]
})
export class PlpFeatureSpotComponent {
	@Input() visualAssets = [];
	@Input() link = '';
	@Input() promotionOptions: 'upTo' | 'startingAt' = 'upTo';
	@Input() discountAmount = '';
	@Input() discountType: 'percent' | 'dollar' = 'percent';
	@Input() dataEm: string;
	@Input() cta: { link: string; linkTitle: string } = {
		linkTitle: '',
		link: ''
	};

	public displayText = {
		upTo: 'up to',
		startingAt: 'starting at'
	};
}
